const Button = {
  baseStyle: {
    borderRadius: 'base',
    fontFamily: 'Karla,sans-serif',
    fontWeight: 'bold',
    lineHeight: 'normal',
  },
  sizes: {
    sm: {
      px: 5,
      py: 2,
    },
    md: {
      px: 5,
      py: 2,
    },
  },
  variants: {
    primary: {
      bg: 'primary',
      border: 'none',
      color: 'white',
      height: '36px',
      ':disabled': {
        bg: 'gray.200',
        color: 'gray.400',
        opacity: 1,
        _hover: {
          bg: 'gray.200',
          color: 'gray.400',
          opacity: 1,
        },
      },
    },
    secondary: {
      bg: 'secondary',
      border: 'none',
      color: 'white',
      height: '36px',
      ':disabled': {
        bg: 'gray.200',
        color: 'gray.400',
        opacity: 1,
        _hover: {
          bg: 'gray.200',
          color: 'gray.400',
          opacity: 1,
        },
      },
    },
    black: {
      bg: 'black',
      border: 'none',
      color: 'white',
      height: '36px',
      ':disabled': {
        bg: 'gray.200',
        color: 'gray.400',
        opacity: 1,
        _hover: {
          bg: 'gray.200',
          color: 'gray.400',
          opacity: 1,
        },
      },
    },
    get blackBig() {
      return {
        ...this.black,
        height: '44px',
      };
    },
    outlined: {
      bg: 'white',
      border: '1px solid',
      borderColor: 'black',
      color: 'black',
      height: '36px',
      ':disabled': {
        bg: 'gray.200',
        color: 'gray.400',
        opacity: 1,
        _hover: {
          bg: 'gray.200',
          color: 'gray.400',
          opacity: 1,
        },
      },
    },
    get outlinedBig() {
      return {
        ...this.outlined,
        height: '44px',
      };
    },
    danger: {
      bg: 'danger',
      border: 'none',
      color: 'white',
      height: '36px',
      ':disabled': {
        _hover: {
          bg: 'danger',
        },
      },
    },
    get dangerBig() {
      return {
        ...this.danger,
        height: '44px',
      };
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'black',
  },
};

export default Button;
